import {
  EthereumIcon,
  FallbackBlankIcon,
  LuksoIcon,
  PolygonIcon,
  SolanaIcon,
} from "@bkry/bowline-components/Icon";
import PropTypes from "prop-types";
import React from "react";

const NetworkLabel = ({ network, size }) => {
  let networkIcon = null;
  switch (network) {
    case "ethereum":
    case "rinkeby":
    case "goerli":
    case "sepolia":
      networkIcon = <EthereumIcon size={size} />;
      break;
    case "polygon":
    case "mumbai":
    case "amoy":
      networkIcon = <PolygonIcon size={size} />;
      break;
    case "lukso":
    case "lukso_testnet":
      networkIcon = <LuksoIcon size={size} />;
      break;
    case "solana":
    case "solana_testnet":
      networkIcon = <SolanaIcon size={size} />;
      break;
    default:
      networkIcon = <FallbackBlankIcon size={size} />;
  }

  return (
    <>
      {networkIcon}
      <span className="ms-1">{network}</span>
    </>
  );
};

NetworkLabel.propTypes = {
  network: PropTypes.string.isRequired,
  size: PropTypes.number,
};

NetworkLabel.defaultProps = {
  size: 16,
};

export default NetworkLabel;
